import { storyblokEditable } from "gatsby-source-storyblok"

import IntroCard from "@components/V2/Cards/IntroCard"
import { storyblokLinkToYocoLink } from "@utils/storyblok"
import React from "react"

const StoryblokIntroCard = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.IntroCard>) => {
  return (
    <IntroCard
      title={blok.title}
      superscriptText={blok.superscriptText}
      size={blok.size}
      description={blok.description}
      image={blok.image?.filename}
      imageAlt={blok.image?.alt}
      isBackgroundImage={blok.isBackgroundImage}
      badge={blok.badge?.[0]}
      price={blok.price}
      priceSuperscript={blok.priceSuperscript}
      ctaText={blok.ctaText}
      ctaColor={blok.ctaColor}
      ctaLink={storyblokLinkToYocoLink(blok.ctaLink)}
      backgroundColor={blok.backgroundColor}
      secondaryBackgroundColor={blok.secondaryBackgroundColor}
      mobileGridOrder={mobileGridOrder}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokIntroCard
